import { render, staticRenderFns } from "./CreditNotePrintView.vue?vue&type=template&id=f84af2c4&"
import script from "./CreditNotePrintView.vue?vue&type=script&lang=js&"
export * from "./CreditNotePrintView.vue?vue&type=script&lang=js&"
import style0 from "./CreditNotePrintView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports